import { AfterViewInit, Component, DoCheck, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit, Output, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { IonContent, Platform } from '@ionic/angular';
import { AppState } from 'src/app/app.service';
import { I18n } from 'src/app/i18n.service';
import { KyperChapters, Path } from 'src/app/path/path-v2.model';
import * as _ from 'underscore';
import { HomeUiService } from '../home-ui.service';
import { ModalController } from '@ionic/angular';
import { User } from 'src/app/user/user.model';
import { ToasterService } from 'src/app/toaster.service';
import { HomeV5Service } from 'src/app/pages/home-v5/home-v5.service';
import { HttpClient } from '@angular/common/http';
import Swiper from 'swiper';
import { DailyStepsContentWebModalV2Component } from '../daily-steps-content-web-modal-v2/daily-steps-content-web-modal-v2.component';
import { AnimationsService } from 'src/app/shared/animations.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MyCommitmentsComponent } from 'src/app/my-commitments/my-commitments.component';
import { AllPathsV2Component } from 'src/app/all-paths-v2/all-paths-v2.component';
import { AlertUnlockLevelComponent } from 'src/app/alert-unlock-level/alert-unlock-level.component';
import { SessionService } from 'src/app/session/session.service';
import { RoutineService } from 'src/app/daily-content-v2/routine.service';
import { FooziAiConciergeService } from '../foozi-ai-concierge.service';
import { collapseAnimation, collapseOnLeaveAnimation, expandOnEnterAnimation, slideOutRightAnimation } from 'angular-animations';
import { DailySteps, ScreenTypes } from 'src/app/path/path-daily-steps-v2.model';

export interface ExcludedSteps {
  steps,
  completedSteps,
  activeStep,
  notStartedStep,
  totalSteps
}
@Component({
  selector: 'app-chapter-complete-screen',
  templateUrl: './chapter-complete-screen.component.html',
  styleUrls: ['./chapter-complete-screen.component.scss'],
   animations: [
   slideOutRightAnimation({duration: 500}),
   collapseAnimation(),
   expandOnEnterAnimation({ duration: 250 }),
   collapseOnLeaveAnimation({ duration: 250 })
  ]
})
export class ChapterCompleteScreenComponent implements OnInit, AfterViewInit {

   isMobile: boolean
  path: Path
  currentDay: number
  @ViewChild('focusableEndChapter') focusableEndChapter: ElementRef;
  @ViewChild(IonContent) content: HTMLIonContentElement;
  @ViewChild('contentWrapper') contentWrapper: ElementRef;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  @ViewChildren('chapterCard') chapterCards: QueryList<ElementRef>;
  @ViewChildren('stepCards') stepCards: QueryList<ElementRef>;
  @ViewChildren('finishStepCards') finishStepCards: QueryList<ElementRef>;
  currentUser: User
  scheduleDay: number
  dailyStepsArray;
  destroyed$ = new Subject<boolean>();
  isMobileWebIos = false;
  isMobileWeb=false;
  chaptersInfo: any =[]; // static data
  finalSortedChaptersInfo: any[] = []
  initialChapterStepsInfo:ExcludedSteps;
  finalChaptertepsInfo:ExcludedSteps;
  userShuffledChapters;
  pathPersonalizationScreeInfo;
  activeChapterIndex;
  animationPhase: number = 0; // 0=expanded active, 1=current chapter completing, 2=next chapter activating
  showCompletedSteps: boolean = true; // keep completing chapter steps expanded for 2s on entry
  animationActive = false;
  @Output() tapAnywhere = new EventEmitter<void>();
  activestepIndex ;
  constructor(private appState: AppState,
    private el : ElementRef,
    public i18n: I18n,
    public http: HttpClient,
    public platform: Platform,
    private modalController: ModalController,
    private homeUIService: HomeUiService,
    private render:Renderer2,
    private homev5Service: HomeV5Service,
    private animationService: AnimationsService,
    private sessionService: SessionService,
    private routineService: RoutineService,
    public toasterService: ToasterService, private fooziAiService: FooziAiConciergeService) {
    this.isMobile = this.appState.get('isMobile')
    this.path = this.appState.get('currentPath')
    this.currentDay = this.appState.get('currentScheduleDay')
    this.currentUser = this.appState.get('currentUser')
    this.scheduleDay = this.appState.get("scheduleDayForCurrentStep")
    this.activeChapterIndex = this.appState.get('currentActiveChapter')
    this.dailyStepsArray = this.appState.get("DailyStepsData");
    this.activestepIndex= this.appState.get('currentActiveStepIndex')

   }
 
  ngOnInit() {
    this.activestepIndex= this.appState.get('currentActiveStepIndex')
    this.isMobileWeb = this.appState.get('MobileWeb')
    this.isMobileWebIos = this.appState.get('MobileWebIos');
    this.userShuffledChapters = this.appState.get('userShuffledChapters');
    this.chaptersInfo =  this.appState.get("DailyStepsData");
    console.log("this.isMobileWeb value", this.isMobileWeb);
   this.getStepArrayInfo();
   this.homeUIService.refreshStepApiData.pipe(takeUntil(this.destroyed$)).subscribe( (data) => {
    if(data){
      console.log("data in your cycle", data);
      this.dailyStepsArray = data.data;
      this.activeChapterIndex = data.currentChapter?.position;
      this.activestepIndex= data.currentChapter?.currentStep?.chapterStepIndex;
      this.updateChapterStepStatus();
    }
  
  });

    this.fetchChaptersSteps()
  }

  updateChapterStepStatus() {
    this.chaptersInfo =  this.appState.get("DailyStepsData");
    const isFinalised = this.userShuffledChapters?.is_finalised ?? this.userShuffledChapters?.isFinalised;
    if ((this.finalSortedChaptersInfo?.length<this.chaptersInfo?.length|| this.activeChapterIndex ==0 ||this.finalSortedChaptersInfo?.length==0) && this.userShuffledChapters && this.userShuffledChapters?.chapterOrder && isFinalised) {
        // Find chapters NOT in order list
        const missingChapters = this.chaptersInfo.filter(c => !this.userShuffledChapters.chapterOrder.includes(c.id));

        const orderedChapters = this.userShuffledChapters?.chapterOrder
          .map(id => this.chaptersInfo.find(c => c.id === id))
          .filter(Boolean); // remove undefined if any

        // Final reordered chapters (missing first, then ordered ones)
        this.finalSortedChaptersInfo = [...missingChapters, ...orderedChapters];
      // Update the initial chapter steps info
    }
    if (this.finalSortedChaptersInfo?.length > 0) {
      if (this.userShuffledChapters && this.userShuffledChapters?.chapterOrder&& (this.userShuffledChapters?.is_finalised ?? this.userShuffledChapters?.isFinalised)) {
        this.scheduleDay = this.appState.get('scheduleDayForCurrentStep')
        this.activeChapterIndex = this.appState.get('currentActiveChapter')
         
        this.finalSortedChaptersInfo.forEach((chapter,i) => {
          const includedSteps = this.chaptersInfo[i]?.steps
          chapter.steps = includedSteps;
          chapter.completedSteps = includedSteps?.filter(s => s?.stepStatus == 'Review')?.length;
          chapter.activeStep = includedSteps?.filter(
            s => s.stepStatus == 'Resume' || (s.position == this.scheduleDay && s.stepStatus !== 'Review')
          )?.length;
          chapter.notStartedStep = includedSteps.filter(
            s => s.position == this.scheduleDay && !s.stepStatus
          )?.length;
          chapter.totalSteps = includedSteps?.length;
        });
      }
      else {
        this.scheduleDay = this.appState.get('scheduleDayForCurrentStep')
        this.activeChapterIndex = this.appState.get('currentActiveChapter')
        this.finalSortedChaptersInfo?.forEach((chapter,i) => {
          const includedSteps = this.chaptersInfo[i]?.steps
     
          chapter.steps = includedSteps;
          chapter.completedSteps = includedSteps?.filter(s => s?.stepStatus == 'Review')?.length;
          chapter.activeStep = includedSteps?.filter(
            s => s.stepStatus == 'Resume' || (s.position == this.scheduleDay && s.stepStatus !== 'Review')
          )?.length;
          chapter.notStartedStep = includedSteps.filter(
            s => s.position == this.scheduleDay && !s.stepStatus
          )?.length;
          chapter.totalSteps = includedSteps?.length;
        });
      }
    }

  }

  fetchChaptersSteps() {
     if (this.chaptersInfo?.length > 0) {
      this.activeChapterIndex = this.appState.get('currentActiveChapter');
       this.activestepIndex = this.appState.get('currentActiveStepIndex');

       // Search ALL chapters for the pathPersonalization screen (not just Chapter 0)
       let ppChapterIndex = -1;
       this.pathPersonalizationScreeInfo = null;
       for (let ci = 0; ci < this.chaptersInfo.length; ci++) {
         const steps = this.chaptersInfo[ci]?.steps;
         if (steps?.length > 0) {
           const stepIdx = steps.findIndex((step: any) =>
             step?.screens?.some((s: any) => s?.screenType === 'pathPersonalization')
           );
           if (stepIdx !== -1) {
             ppChapterIndex = ci;
             this.pathPersonalizationScreeInfo = this.path.filterStepsByContentType('pathPersonalization', steps[stepIdx]);
             break;
           }
         }
       }

    // //  Reorder chapters as per chapterorder , neeed to uncomment when working on reoder chapters flow
      if (this.userShuffledChapters && this.userShuffledChapters?.chapterOrder && (this.userShuffledChapters?.is_finalised ?? this.userShuffledChapters?.isFinalised)) {
        // Find chapters NOT in order list
        const missingChapters = this.chaptersInfo.filter(c => !this.userShuffledChapters.chapterOrder.includes(c.id));
        const orderedChapters = this.userShuffledChapters?.chapterOrder
          .map(id => this.chaptersInfo.find(c => c.id === id))
          .filter(Boolean); // remove undefined if any

        // Final reordered chapters (missing first, then ordered ones)
        this.finalSortedChaptersInfo = [...missingChapters, ...orderedChapters];
      }
      else {
        if (this.pathPersonalizationScreeInfo?.length > 0) {
          // Always show all chapters up to and including the path personalization chapter
          // so prior chapters remain accessible until personalization is finalized.
          this.finalSortedChaptersInfo = this.chaptersInfo.slice(0, ppChapterIndex + 1);
        }
        else {
          this.finalSortedChaptersInfo = this.chaptersInfo;
        }
     }
      this.scheduleDay = this.appState.get('scheduleDayForCurrentStep')
      this.activeChapterIndex = this.appState.get('currentActiveChapter');
 
      // Attach steps for each chapter based on start_step & end_step
       if (this.userShuffledChapters && this.userShuffledChapters?.chapterOrder && (this.userShuffledChapters?.is_finalised ?? this.userShuffledChapters?.isFinalised) ) {
         this.finalSortedChaptersInfo = this.finalSortedChaptersInfo.map(chapter => {
          const includedSteps = chapter.steps
           const completedStepsLength = includedSteps.filter(s => s.stepStatus == 'Review')
           const activeStep = includedSteps.filter(s => s.stepStatus == 'Resume' || (s?.position == this.scheduleDay && s.stepStatus !== 'Review'))
           const notStartedStep = includedSteps.filter(s => s.position == this.scheduleDay && !s.stepStatus)
           return { ...chapter, steps: includedSteps, completedSteps: completedStepsLength?.length, activeStep: activeStep?.length, notStartedStep: notStartedStep?.length, totalSteps: includedSteps?.length };
         });
       }
       else if(this.finalSortedChaptersInfo?.length>0){
          this.finalSortedChaptersInfo = this.finalSortedChaptersInfo.map(chapter => {
        const includedSteps = chapter.steps
        const completedStepsLength = includedSteps.filter(s => s.stepStatus == 'Review')
        const activeStep= includedSteps.filter(s=>s.stepStatus=='Resume'|| (s.position==this.scheduleDay && s.stepStatus !== 'Review'))
        const notStartedStep = includedSteps.filter(s =>  s.position == this.scheduleDay && !s.stepStatus)
        return { ...chapter, steps: includedSteps, completedSteps: completedStepsLength?.length, activeStep: activeStep?.length, notStartedStep: notStartedStep?.length, totalSteps: includedSteps?.length };
      });
       }
      console.log(this.finalSortedChaptersInfo);
     }
  }
  areAllChaptersStepsReviewed() {
    return this.dailyStepsArray.every(chapter =>
      chapter.steps.every(step => step.stepStatus === "Review")
    );
  }
  progressBarGradient(chapterInfo) {
    let totSteps = chapterInfo?.totalSteps;
    let currentStep =
      chapterInfo?.completedSteps === 0 && chapterInfo?.activeStep === chapterInfo?.notStartedStep
        ? 0
        : chapterInfo?.completedSteps > 0
          ? chapterInfo?.completedSteps + (chapterInfo?.activeStep === chapterInfo?.notStartedStep ? 0 : chapterInfo?.activeStep / 2)
          : chapterInfo?.activeStep / 2;
    const stepSize = 100 / totSteps;
    const stepPercentage = stepSize * currentStep;
    const completedStepGradient = `${stepPercentage}%`;
    return completedStepGradient;
  }
  progressStepBarGradient(currentStep) {
    let data = this.appState.get("screensViewed")
    if (!data || data == undefined) {
      if (this.appState.get('pathRegistration')) {
        data = this.appState.get('pathRegistration')?.screensViewed
      }
      else {
        return 0;
      }
    }
    let stepObjects
    if (data) {
      stepObjects = data.filter(item => item.step === currentStep?.position);
    }
    if (stepObjects?.length === 0 || !data) return 0;

    // take the last one
    const lastStep = stepObjects[stepObjects?.length - 1];
    const stepPercentage = (lastStep?.visitedScreens / lastStep?.totalScreens) * 100;
    const completedStepGradient = `${stepPercentage}%`;
    return completedStepGradient;
  }
  changeSubTextFont(stepTitle,index) {
   if(stepTitle) {
     // const element = stepTitle?.toArray()[index]?.nativeElement;
     const element = stepTitle?.el
    const specificElement = element?.querySelector('p') || element?.querySelector('h1') || element?.querySelector('h2');
    if(specificElement) {
      this.render.setStyle(specificElement, 'font-size', '20px');
      this.render.setStyle(specificElement, 'font-weight', '500');
      this.render.setStyle(specificElement, 'font-style', 'normal');
      this.render.setStyle(specificElement, 'line-height', '23.44px');
      this.render.setStyle(specificElement, 'font-family', 'Roboto');
     this.render.setStyle(specificElement, 'word-break', 'break-word');
     this.render.setStyle(specificElement, 'overflow', 'hidden');
     this.render.setStyle(specificElement, ' text-overflow', 'ellipsis');
     this.render.setStyle(specificElement, 'display', '-webkit-box');
     this.render.setStyle(specificElement, '-webkit-line-clamp', '2');
     this.render.setStyle(specificElement, 'margin-bottom', '8px');
     this.render.setStyle(specificElement, '-webkit-box-orient', 'vertical');

    }
  return true;
   }

  }
  async getStepArrayInfo(){
     let stepBegin= false;
      let stepCount = 1;
      await  this.dailyStepsArray?.forEach((chapter) => {
          chapter?.steps?.forEach((stepItem: DailySteps, i) => {
            if (stepItem?.stepStatus === "Review" && i < chapter?.steps?.length) {
              stepCount += 1
              this.appState.set('scheduleDayForCurrentStep', stepCount);
              this.appState.set("currentScheduleDay", stepCount);
            }
            else if (stepItem?.stepStatus == 'Resume') {
              this.appState.set("currentScheduleDay", stepCount)
              this.appState.set('scheduleDayForCurrentStep', stepCount);
              stepBegin = true
            }
            else if (!stepItem?.stepStatus && !stepBegin) {
              this.appState.set("currentScheduleDay", stepCount)
              this.appState.set('scheduleDayForCurrentStep', stepCount);
              stepBegin = true
            }
          });
        });
    this.updateChapterStepStatus();
  }

  ngDoCheck(): void {
    // this.dailyStepsArray= this.appState.get("DailyStepsData");
    this.userShuffledChapters = this.appState.get('userShuffledChapters');
    this.scheduleDay = this.appState.get("scheduleDayForCurrentStep")
    this.activeChapterIndex = this.appState.get('currentActiveChapter')
    this.activestepIndex= this.appState.get('currentActiveStepIndex')
    this.currentDay = this.appState.get('currentScheduleDay')
    this.path = this.appState.get('currentPath');
  }

  ngAfterViewInit() {
    if (this.content) {
      this.content.scrollToTop(0);
    } else if (this.scrollContainer?.nativeElement) {
      this.scrollContainer.nativeElement.scrollTop = 0;
    }
    setTimeout(() => { this.animationActive = true; }, 0);
    this.homeUIService.expandOnEnterAnimation();
    setTimeout(() => { this.showCompletedSteps = false; this.animationPhase = 1; }, 3000); // collapse completing chapter steps after 3s
    setTimeout(() => {
      this.animationPhase = 3;                                          // activate next chapter
      setTimeout(() => this.tapAnywhere.emit(), 3000);  // show step-final-weldone-screen
    }, 5000);
  }

  // Completing chapter = last fully-done chapter whose immediate successor is not yet done
  // Read the chapter index snapshotted by the parent at the moment it triggered this screen.
  // Falls back to activeChapterIndex so the completing chapter is still identified even when
  // the snapshot was not stored (e.g. last chapter has no next chapter so the parent skips it).
  private get _completingIdx(): number {
    const stored = this.appState.get('completingChapterIndex');
    if (stored !== null && stored !== undefined && stored >= 0) return stored;
    return this.activeChapterIndex ?? -1;
  }

  isCompletingChapter(chapter: any): boolean {
    if (!chapter || this._completingIdx < 0) return false;
    const idx = this.finalSortedChaptersInfo?.indexOf(chapter);
    return idx === this._completingIdx;
  }

  isNextChapterAfterCompleting(chapter: any): boolean {
    if (!chapter || this._completingIdx < 0) return false;
    const idx = this.finalSortedChaptersInfo?.indexOf(chapter);
    return idx === this._completingIdx + 1;
  }

  // Number of the phase that was just completed — matches the numbering rendered against
  // each chapter in the list (index 0 is the kickoff chapter, so numbering starts at 1).
  getRecentCompletedPhaseNumber(): number {
    return this._completingIdx;
  }

  getRecentPhaseCompleteTitle(): string {
    const phaseNumber = this.getRecentCompletedPhaseNumber();
    return phaseNumber > 0
      ? `${this.i18n.t('Phase')} ${phaseNumber} ${this.i18n.t('completed')}!`
      : `${this.i18n.t('Phase completed')}!`;
  }

  getNextChapterFirstStepImage(): string {
    return this.chaptersInfo?.[this.activeChapterIndex + 1]?.steps?.[0]?.step?.image ?? '';
  }

  getNextChapterFirstStepTitle(): string {
    return this.chaptersInfo?.[this.activeChapterIndex + 1]?.steps?.[0]?.step?.title ?? '';
  }

   trackByChapter(index: number, chapter: any) {
    return chapter.id || chapter.position || index;
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

}
